import React, { Component } from 'react';
import { Translation } from 'react-i18next';
import PropTypes from 'prop-types';
import { loginCopy } from '../copy/loginCopy.json';

export default class LandingIntroButtons extends Component {
  primaryColor = {
    color: this.props.color,
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div className="mobile-intro-container">
            <div
              className="intro-icon-container-whole"
              role="button"
              tabIndex={0}
              onClick={this.props.showVideo}
              onKeyPress={this.props.showVideo}
            >
              <div className="intro-icon-svg-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="38.697"
                  height="38.697"
                  viewBox="0 0 38.697 38.697"
                  role="img"
                >
                  <title>{t('Watch me3 Intro Video')}</title>
                  <g transform="translate(-9 -961.362)">
                    <path
                      fill={this.props.color}
                      d="M28.349,961.362A19.349,19.349,0,1,0,47.7,980.711,19.363,19.363,0,0,0,28.349,961.362Zm0,1.888a17.461,17.461,0,1,1-17.461,17.461A17.447,17.447,0,0,1,28.349,963.25Zm-5.014,8.495A2.136,2.136,0,0,0,21.27,973.9v13.612a2.127,2.127,0,0,0,3.171,1.888l11.8-6.828a2.142,2.142,0,0,0,0-3.716l-11.8-6.828a2.206,2.206,0,0,0-1.106-.28Z"
                    />
                  </g>
                </svg>
              </div>

              <p className="label-text intro-text" style={this.primaryColor}>
                {t('Watch: What is {{appName}}?', { appName: 'me3' })}
              </p>
            </div>
            <div
              className="intro-icon-container-whole"
              role="button"
              onClick={this.props.goToIntro}
              onKeyPress={this.props.goToIntro}
              tabIndex={0}
            >
              <div className="intro-icon-svg-container">
                <svg
                  width="41.697"
                  height="41.697"
                  fill={this.props.color}
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 100 100"
                  xmlSpace="preserve"
                  role="img"
                >
                  <title>{t('Read about me3')}</title>
                  <g>
                    <g>
                      <g>
                        <path d="M95.5,25.4h-8.4v-5.2c0-1.1-0.9-2-2-2c-12.1,0-24,2.4-35.2,7c-11.2-4.7-23-7-35.2-7c-1.1,0-2,0.9-2,2v5.2H4.5     c-1.1,0-2,0.9-2,2v52.5c0,1.1,0.9,2,2,2h91.1c1.1,0,2-0.9,2-2V27.3C97.5,26.3,96.6,25.4,95.5,25.4z M52,77V28.7     c10-4.1,20.5-6.3,31.3-6.6v48.6C72.4,70.9,62,73.1,52,77z M16.8,22.1C27.6,22.4,38,24.6,48,28.7V77c-10-3.9-20.5-6.1-31.3-6.3     V22.1z M6.4,29.3h6.5v43.4c0,1.1,0.9,2,2,2c8,0,15.8,1.2,23.4,3.3H6.4V29.3z M93.6,77.9H61.7c7.6-2.1,15.4-3.3,23.4-3.3     c1.1,0,2-0.9,2-2V29.3h6.5V77.9z" />
                        <path d="M24.1,34.6c5.3,0.6,10.6,1.6,15.7,3.2c0.2,0.1,0.4,0.1,0.6,0.1c0.8,0,1.6-0.6,1.9-1.4c0.3-1-0.3-2.1-1.3-2.4     c-5.4-1.6-10.9-2.7-16.4-3.3c-1.1-0.1-2,0.7-2.2,1.7C22.3,33.5,23.1,34.5,24.1,34.6z" />
                        <path d="M41,43.5c-5.4-1.6-10.9-2.7-16.4-3.3c-1.1-0.1-2,0.7-2.2,1.7c-0.1,1.1,0.7,2,1.7,2.2c5.3,0.6,10.6,1.6,15.7,3.2     c0.2,0.1,0.4,0.1,0.6,0.1c0.8,0,1.6-0.5,1.9-1.4C42.6,44.9,42,43.8,41,43.5z" />
                        <path d="M41,53c-5.4-1.6-10.9-2.7-16.4-3.3c-1.1-0.1-2,0.7-2.2,1.7c-0.1,1.1,0.7,2,1.7,2.2c5.3,0.6,10.6,1.6,15.7,3.2     c0.2,0.1,0.4,0.1,0.6,0.1c0.8,0,1.6-0.5,1.9-1.4C42.6,54.4,42,53.3,41,53z" />
                        <path d="M41,62.4c-5.4-1.6-10.9-2.7-16.4-3.3c-1.1-0.1-2,0.7-2.2,1.7c-0.1,1.1,0.7,2,1.7,2.2c5.3,0.6,10.6,1.6,15.7,3.2     c0.2,0.1,0.4,0.1,0.6,0.1c0.8,0,1.6-0.5,1.9-1.4C42.6,63.8,42,62.7,41,62.4z" />
                        <path d="M75.4,30.7C69.9,31.3,64.4,32.4,59,34c-1,0.3-1.6,1.4-1.3,2.4c0.3,0.8,1,1.4,1.9,1.4c0.2,0,0.4,0,0.6-0.1     c5.2-1.5,10.5-2.6,15.7-3.2c1.1-0.1,1.9-1.1,1.7-2.2C77.5,31.4,76.5,30.6,75.4,30.7z" />
                        <path d="M75.4,40.2c-5.5,0.6-11.1,1.7-16.4,3.3c-1,0.3-1.6,1.4-1.3,2.4c0.3,0.8,1,1.4,1.9,1.4c0.2,0,0.4,0,0.6-0.1     c5.1-1.5,10.4-2.6,15.7-3.2c1.1-0.1,1.9-1.1,1.7-2.2C77.5,40.8,76.5,40,75.4,40.2z" />
                        <path d="M75.4,49.6C69.9,50.2,64.3,51.4,59,53c-1,0.3-1.6,1.4-1.3,2.4c0.3,0.8,1,1.4,1.9,1.4c0.2,0,0.4,0,0.6-0.1     c5.1-1.5,10.4-2.6,15.7-3.2c1.1-0.1,1.9-1.1,1.7-2.2C77.5,50.3,76.5,49.5,75.4,49.6z" />
                        <path d="M75.4,59.1c-5.5,0.6-11.1,1.7-16.4,3.3c-1,0.3-1.6,1.4-1.3,2.4c0.3,0.8,1,1.4,1.9,1.4c0.2,0,0.4,0,0.6-0.1     c5.1-1.5,10.4-2.6,15.7-3.2c1.1-0.1,1.9-1.1,1.7-2.2C77.5,59.8,76.5,59,75.4,59.1z" />
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <p
                role="button"
                className="label-text intro-text"
                style={this.primaryColor}
              >
                {t('Read {{appName}} introduction', { appName: 'me3' })}
              </p>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

LandingIntroButtons.propTypes = {
  color: PropTypes.string.isRequired,
};
